import { useState } from "react";
import useLocalStorage from "./useLocalStorage";

export default function useChangeBtn() {
  const [detail, setDetail] = useState({});
  const [btnText, setBtnText] = useState("SAVE");
  const [btnColor, setBtnColor] = useState("");
  const [disable, setDisable] = useState(false);
  const { fav, setFav } = useLocalStorage();

  const changeColor = () => {
    setBtnColor("green");
  };

  const changeTextBtn = () => {
    addToMyList(detail);
    setBtnText("SAVED");
    changeColor();
    setDisable(true);
    console.log(btnColor, btnText);
    console.log(detail);
  };

  const addToMyList = () => {
    setFav([detail.id, ...fav]);
    console.log(fav);
    console.log(detail.id);
  };

  return {
    detail,
    setDetail,
    btnText,
    setBtnText,
    btnColor,
    setBtnColor,
    disable,
    setDisable,
    changeColor,
    changeTextBtn,
    addToMyList,
    fav,
    setFav,
  };
}
